import { SystemParametersListItem } from 'ducks/system-parameters-list/slices';
import { ProjectParameter } from 'ducks/types/common-types';

export const checkNullableDate = (date: string | null | undefined) => {
  return !!(date !== undefined && date !== null);
};

export const getCheckBoxTheme = <TTheme extends Record<'font_color' | 'checkbox_color_active', string>>(
  theme: TTheme,
) => {
  return {
    checkbox_font_size: '13px',
    checkbox_color: theme.font_color,
    checkbox_color_active: theme.checkbox_color_active,
  };
};

export const getAdvFilteringTheme = <TTheme extends Record<'font_color', string>>(theme: TTheme) => {
  return {
    switch_on_color: '#276EF1',
    label_font_color_active: '#276EF1',
    label_font_color: theme.font_color,
  };
};

// TODO: add batch type
export const findCurrentBatch = (batch: any[], id: number | null) => {
  return batch.find((el) => el?.batch_definition_item_id === id);
};

export const getCardInfoParams = (childrenLength: number, paramsLength: number) => {
  const cardChildrenLength = childrenLength || 0;
  const currentParamsLength = paramsLength || 0;
  const arrayLength = Math.max(Math.abs(cardChildrenLength - currentParamsLength) + 1, 0);
  const length = new Array(arrayLength).fill({ empty: true });
  return length;
};

export const getParameterSelectData = (id: string | number, name: string | number) => {
  const data = {
    id,
    name,
    command_line_prefix: '--',
    command_line_assignment_char: '=',
    command_line_escaped: true,
    command_line_ignore_name: false,
    is_encrypted: false,
    parameter_method_id: +id,
    parameter_method_name: String(name),
  };

  if (id === 1) {
    data.command_line_prefix = '--';
    data.command_line_assignment_char = '=';
    data.command_line_escaped = true;
    data.command_line_ignore_name = false;
  }

  if (id === 2) {
    data.is_encrypted = false;
  }

  return data;
};

const applyDataValueIfAws = <TData>(data: TData, parameter_name: string | number) => {
  if (parameter_name === 'aws_access_key_id' || parameter_name === 'aws_secret_access_key') {
    const modified = {
      is_required: true,
      is_encrypted: true,
      parameter_method_name: 'Environment Variable',
      parameter_method_id: 2,
    };
    return { ...data, ...modified };
  }

  return data;
};

export const getSystemReferenceData = (item: SystemParametersListItem) => {
  const data = {
    reference_parameter_name: String(item.system_parameter_name),
  };
  const aws_data = applyDataValueIfAws(data, item.system_parameter_name);
  return aws_data;
};

export const getNewParameterRow = <Key extends keyof ProjectParameter>(key: Key, value: ProjectParameter[Key]) => {
  return {
    [key]: value,
  };
};
